import React from 'react';
import PropTypes from 'prop-types';
import { withModifiers } from '../../decorators';
import classNames from 'classnames';
import Text from '../text';

var SearchBarList = function SearchBarList(_ref) {
  var className = _ref.className,
      children = _ref.children,
      isActive = _ref.isActive,
      title = _ref.title;
  return React.createElement("div", {
    className: classNames('search-results', className, {
      'is-active': isActive
    })
  }, React.createElement(SearchBarList.Text, {
    className: "suptitle"
  }, title), React.createElement("ul", {
    className: "menu-list dropdown-menu-list"
  }, children && typeof children.valueOf() === 'string' ? React.createElement(SearchBarList.Text, {
    content: children
  }) : children));
};

SearchBarList.propTypes = {
  children: PropTypes.any,
  className: PropTypes.string,
  title: PropTypes.string,
  isActive: PropTypes.bool
};
SearchBarList.Text = Text;
SearchBarList.displayName = 'SearchBar.List';
export default withModifiers(SearchBarList);